<button
  [type]="btnType"
  [title]="title"
  (click)="onClickButton($event)"
  class="{{ baseClasses }} {{ roundedClasses }} {{ sizeClasses }} {{ textClasses }} {{ colorClasses }} {{ disableClasses }} {{
    btnClasses
  }} {{ btnTextClass }}"
  [disabled]="disabled"
  [routerLink]="link"
>
  @if (spinner) {
    <span class="btn-spinner">
      <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
    </span>
  }

  @if (!spinner) {
    <span class="{{ btnTextClass }}"><ng-content></ng-content></span>
  }
</button>
